/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * User-editable business status of the supplement
 * @export
 */
export const SupplementStatus = {
    Draft: 'draft',
    Submitted: 'submitted',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;
export type SupplementStatus = typeof SupplementStatus[keyof typeof SupplementStatus];


export function instanceOfSupplementStatus(value: any): boolean {
    for (const key in SupplementStatus) {
        if (Object.prototype.hasOwnProperty.call(SupplementStatus, key)) {
            if (SupplementStatus[key as keyof typeof SupplementStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SupplementStatusFromJSON(json: any): SupplementStatus {
    return SupplementStatusFromJSONTyped(json, false);
}

export function SupplementStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplementStatus {
    return json as SupplementStatus;
}

export function SupplementStatusToJSON(value?: SupplementStatus | null): any {
    return value as any;
}

export function SupplementStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): SupplementStatus {
    return value as SupplementStatus;
}

